import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import DeviceHome from '../views/home/DeviceHome.vue'
import BindingDevice from '../views/BindingDevice'
import Auth from '../views/Auth'

Vue.use(VueRouter);

  const routes = [
  {
    path: '/',
    name: '首页',
    component: Home,
    children:[
      {
        path: 'home/index',
        name: '首页-设备',
        component: DeviceHome,
        meta: {
          wxApi: true
        }
      },{
        path: 'home/bindingDevice',
        name: '首页-绑定设备',
        component: () => import(/* webpackChunkName: "bindingDeviceHome" */ '../views/home/BindingDeviceHome.vue'),
        meta: {
          wxApi: true
        }
      },{
        path: 'home/bindingMobile',
        name: '首页-绑定手机号',
        component: () => import(/* webpackChunkName: "bindingMobileHome" */ '../views/home/BindingMobileHome.vue')
      },{
        path: 'home/addMember',
        name: '首页-添加成员',
        component: () => import(/* webpackChunkName: "AddMemberHome" */ '../views/home/AddMemberHome.vue')
      },{
        path: 'home/addReportHome',
        name: '首页-上传数据',
        component: () => import(/* webpackChunkName: "AddReportHome" */ '../views/home/AddReportHome.vue'),
        props: (route) => {
          return route.query
        }
      }
    ]
  }, {
      path: '/bindingMobile',
      name: '绑定手机号',
      component: () => import(/* webpackChunkName: "bindingMobile" */ '../views/BindingMobile.vue'),
    },
    {
      path: '/userCenter',
      name: '个人中心',
      component: () => import(/* webpackChunkName: "userCenter" */ '../views/UserCenter.vue'),
    },
    {
      path: '/member',
      name: '我的成员',
      component: () => import(/* webpackChunkName: "member" */ '../views/Member.vue'),
    },
    {
      path: '/useHistory',
      name: '使用记录',
      component: () => import(/* webpackChunkName: "deviceUseHistory" */ '../views/DeviceUseHistory.vue'),
    },
    {
      path: '/rechargeHistory',
      name: '充值记录',
      component: () => import(/* webpackChunkName: "rechargeHistory" */ '../views/RechargeHistory.vue'),
    },
    {
      path: '/reportHistory',
      name: '历史数据',
      component: () => import(/* webpackChunkName: "reportHistory" */ '../views/ReportHistory.vue'),
    },
    {
      path: '/addReport',
      name: '上次数据',
      component: () => import(/* webpackChunkName: "addReport" */ '../views/AddReport.vue'),
    },
    {
      path: '/reportDetail/:id',
      name: '数据详情',
      component: () => import(/* webpackChunkName: "reportDetail" */ '../views/ReportDetail.vue'),
      props: true
    },
    {
      path: '/binding/device/:deviceNo',
      name: '绑定设备',
      component: BindingDevice,
      props: true
    },
    {
      path: '/auth',
      name: '登录认证',
      component: Auth,
      props: (route) => {
        return route.query
      }
    }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router
